import { teamRoles } from "astrid-firestore/src/constants/teamRoles";

export default function sortProductionTeam(a, b) {
	if (a.role === teamRoles.MANAGER && b.role !== teamRoles.MANAGER) {
		return -1;
	}

	if (a.role !== teamRoles.MANAGER && b.role === teamRoles.MANAGER) {
		return 1;
	}

	return a.user.name?.localeCompare(b.user.name);
}
